module.exports = __webpack_public_path__ + "static/media/House.999b8cb6.svg";